import React from 'react';
import { Routes, Route, Link } from 'react-router-dom';
import ProductMaintenance from '../components/Maintenance/Products/ProductMaintenance';
import ClientMaintenance from '../components/Maintenance/Clients/ClientMaintenance';
import ProviderMaintenance from '../components/Maintenance/Providers/ProviderMaintenance';
import { useAuth } from '../context/AuthContext';
import '../styles/Maintenance.css';

function MaintenancePage({ businessId }) {
  const { user } = useAuth();
  return (
    <div className="maintenance-page">
      <Routes>
        <Route path="products/*" element={<ProductMaintenance businessId={businessId} />} />
        <Route path="clients/*" element={<ClientMaintenance businessId={businessId} />} />
        <Route path="providers/*" element={<ProviderMaintenance businessId={businessId} />} />
        <Route path="/" element={<MaintenanceMenu user={user} />} />
      </Routes>
    </div>
  );
}

function MaintenanceMenu({ user }) {
  return (
    <div className="maintenance-menu">
      <h1>Módulo de Mantenimiento</h1>
      <div className="menu-options">
        <div className="menu-card">
          <h3>Productos</h3>
          <p>Gestionar productos, categorías e inventario</p>
          <Link to="/maintenance/products" className="btn btn-primary">Acceder</Link>
        </div>
        <div className="menu-card">
          <h3>Clientes</h3>
          <p>Administrar clientes y créditos</p>
          <Link to="/maintenance/clients" className="btn btn-primary">Acceder</Link>
        </div>
        <div className="menu-card">
          <h3>Proveedores</h3>
          <p>Gestionar proveedores y cuentas por pagar</p>
          <Link to="/maintenance/providers" className="btn btn-primary">Acceder</Link>
        </div>
        {user?.role === 'admin' && (
          <div className="menu-card">
            <h3>Usuarios</h3>
            <p>Administrar usuarios y roles del sistema</p>
            <Link to="/usuarios" className="btn btn-primary">Acceder</Link>
          </div>
        )}
      </div>
    </div>
  );
}

export default MaintenancePage;
